import { PIT_COLLISION } from './pit-collision.js';
/** Both the offline scaler and production consume this collision conversion. */
export function createBlenderPitMap(asset, { width = 1.6, height = 1, playerCount = 8 } = {}) {
    for (const scale of [width, height]) {
        if (!Number.isFinite(scale) || scale <= 0)
            throw new RangeError('Scale must be positive and finite');
    }
    if (!Number.isInteger(playerCount) || playerCount < 1 || playerCount > asset.spawns.length) {
        throw new RangeError(`Pit supports 1–${asset.spawns.length} players`);
    }
    return {
        id: 'crucible', name: 'The Pit',
        platforms: asset.colliders.map((box, i) => {
            const w = box.fixedScale ? 1 : width, h = box.fixedScale ? 1 : height;
            return { id: `pit-${i}`, partId: box.partId ?? 'floor',
                x: box.x * w, y: box.y * h, z: box.z * w,
                hx: box.hx * w, hy: box.hy * h, hz: box.hz * w, solid: true,
                surface: box.hazard ? { kind: 'hazard', dps: 12 } : { kind: 'normal' } };
        }),
        spawns: asset.spawns.slice(0, playerCount).map(p => ({ x: p.x * width, y: p.y * height + 1, z: p.z * width })),
        floor: { kind: 'none' }, mutationFloorY: (asset.mutationFloorY ?? .035) * height,
        visual: { asset: '/models/arenas/pit-v1.json', width, height },
        windZones: [], killY: -12, centerX: 0, centerZ: 0,
        startRadius: asset.radius * width, floorRadius: asset.radius * width, zoneCenterJitter: 0,
    };
}
export function createProductionPit(opts) {
    // An explicit radius is the actual radius published in world_init, not a
    // second design-scale multiplier. Echoing it must reproduce the same map.
    const width = opts?.radius === undefined ? 1.6 : opts.radius / PIT_COLLISION.radius;
    return createBlenderPitMap(PIT_COLLISION, { width, playerCount: opts?.playerCount });
}
//# sourceMappingURL=pit.js.map